import { PropsWithChildren, useEffect } from 'react';
import { CHAKRA_CONFIG } from '~/constants/chakra';
import { useAppStore } from '~/store/useAppStore';
import { useWindowSize } from '~/hooks/useWindowSize';

export const MobileProvider = ({ children }: PropsWithChildren) => {
  const setIsMobile = useAppStore((state) => state.setIsMobile);
  const { width: innerWidth } = useWindowSize();

  // Update mobile state when window width changes
  useEffect(() => {
    if (typeof window === 'undefined' || !innerWidth) return;

    // Keep the JS mobile detection exactly in-sync with chakra
    // We use chakra's mobile detection 99% of the time for UI
    // so that must be considered the source-of-truth
    // Not using other methods like navigator agent
    const isMobile = innerWidth < CHAKRA_CONFIG.MOBILE_BREAKPOINT;
    setIsMobile(isMobile);
  }, [innerWidth]);

  return children;
};
